/**
 * Set cookie.
 * @param {String} name
 * @param {String} value
 * @param {Number|false} days
 * @param {Boolean} sameSite
 * @returns Void
 */
var setCookie = (name, value, days, sameSite) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie =
    name +
    '=' +
    (value || '') +
    expires +
    '; path=/' +
    (sameSite ? '; SameSite=None; Secure' : '');
};

/**
 * Get cookie data.
 * @param {String} name
 * @returns {String|Null}|
 */
var getCookie = name => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0)
      return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Erase cookie value
 * @param {String} name
 */
var eraseCookie = name => {
  document.cookie = name + '=; Max-Age=-99999999';
};
